export const ProductsData = [
    {
        id:10,
        name:'el salvador coffe',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore quidem qui',
        image:'https://img-kahvedunyasi.mncdn.com/kahvedunyasi/product/250x250/78b80_El_Salvador_Yoresel_Kahve_200g.png',
        price:59
    },
    {
        id:11,
        name:'colombia coffee',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore quidem qui',
        image:'https://img-kahvedunyasi.mncdn.com/kahvedunyasi/product/250x250/11ec9_Kolombiya_Yoresel_Kahve_200g.png',
        price:89
    },
    {
        id:12,
        name:'antigua coffee',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore quidem qui',
        image:'https://img-kahvedunyasi.mncdn.com/kahvedunyasi/product/250x250/f13c3_Antigua_Yoresel_Kahve_200g.png',
        price:119
    },
    {
        id:13,
        name:'kenya coffee',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore quidem qui',
        image:'https://img-kahvedunyasi.mncdn.com/kahvedunyasi/product/250x250/82a27_Kenya_Yoresel_Kahve_200g.png',
        price:49
    },
    {
        id:14,
        name:'santos coffee',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore quidem qui',
        image:'https://img-kahvedunyasi.mncdn.com/kahvedunyasi/product/250x250/40cad_Santos_Yoresel_Kahve_200g.png',
        price:99
    },
    {
        id:15,
        name:'guatemala coffee',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore quidem qui',
        image:'https://img-kahvedunyasi.mncdn.com/kahvedunyasi/product/250x250/70d54_Guatemala_Yoresel_Kahve_200g.png',
        price:79
    },
    {
        id:16,
        name:'capsul coffee classico',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore quidem qui',
        image:'https://img-kahvedunyasi.mncdn.com/kahvedunyasi/product/250x250/50bf8_Kapsul_Kahve_Classico.png',
        price:29
    },
    {
        id:17,
        name:'capsul coffee ristretto',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore quidem qui',
        image:'https://img-kahvedunyasi.mncdn.com/kahvedunyasi/product/250x250/5b817_Kapsul_Kahve_Ristretto.png',
        price:39
    },

]